import {
  FETCH_LOAD_ALL_SUGGESTED_USERS_REQUEST,
  FETCH_LOAD_ALL_SUGGESTED_USERS_SUCCESS,
  FETCH_LOAD_ALL_SUGGESTED_USERS_FALUIRE,
} from './userNameSuggestionsTypes'

const initialState = {
  loading: false,
  allSuggestedUsersList: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_LOAD_ALL_SUGGESTED_USERS_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_LOAD_ALL_SUGGESTED_USERS_SUCCESS : return {
      ...state,
      allSuggestedUsersList: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_LOAD_ALL_SUGGESTED_USERS_FALUIRE : return {
      ...state,
      loading: false,
      allSuggestedUsersList: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
